import { render, staticRenderFns } from "./addKnowledge.vue?vue&type=template&id=039c940a&scoped=true&"
import script from "./addKnowledge.vue?vue&type=script&lang=js&"
export * from "./addKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./addKnowledge.vue?vue&type=style&index=0&id=039c940a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c940a",
  null
  
)

export default component.exports